import isString from "lodash/isString";
import { useDownload } from "PFCore/helpers/use_download";
import { JsonObject } from "type-fest";

type UseDownloadTextFileReturn = (fileName: string, content: string | JsonObject) => void;

export const useDownloadTextFile = (): UseDownloadTextFileReturn => {
  const download = useDownload();
  return (fileName: string, content: string | JsonObject) =>
    download(fileName, isString(content) ? content : JSON.stringify(content), "text/plain;charset=utf-8");
};
